import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LuLayoutDashboard,
  LuClipboardList,
  LuSettings,
  LuMapPin,
  LuShield,
  LuShoppingBag,
} from "react-icons/lu";

const NAV = [
  { path: "/dashboard",        label: "Dashboard",        Icon: LuLayoutDashboard },
  { path: "/orders",           label: "My Orders",        Icon: LuClipboardList   },
  { path: "/account/settings", label: "Account Settings", Icon: LuSettings        },
  { path: "/shipping-address", label: "Shipping Address", Icon: LuMapPin          },
  { path: "/account/security", label: "Security",         Icon: LuShield          },
];

export default function AccountLayout({ children, title }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const initials = (user?.displayName || user?.email || "U")
    .split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);

  return (
    <div className="min-h-screen bg-background font-sans flex">
      {/* Sidebar */}
      <aside className="hidden md:flex flex-col w-60 bg-card border-r border-border sticky top-[88px] h-[calc(100vh-88px)] py-8 shrink-0">
        {/* User info */}
        <div className="px-6 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-brand-navy flex items-center justify-center text-white font-black text-lg mb-3">
            {initials}
          </div>
          <p className="font-bold text-foreground text-sm truncate">{user?.displayName || "Account"}</p>
          <p className="text-xs text-[var(--color-muted-foreground)] truncate mt-0.5">{user?.email}</p>
        </div>

        <nav className="flex flex-col gap-0.5 px-3 flex-1">
          {NAV.map(({ path, label, Icon }) => {
            const active = pathname === path;
            return (
              <Link
                key={path}
                to={path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-all ${
                  active
                    ? "bg-brand-navy text-white"
                    : "text-slate-500 dark:text-slate-400 hover:text-brand-navy dark:hover:text-white hover:bg-slate-50 dark:hover:bg-white/5"
                }`}
              >
                <Icon size={16} className="flex-shrink-0" />
                {label}
              </Link>
            );
          })}
        </nav>

        <div className="px-4 mt-4">
          <Link to="/products/disposable-vapes" className="flex items-center gap-2 w-full bg-brand-amber text-white text-xs font-bold px-4 py-3 rounded-xl hover:brightness-110 transition-all justify-center">
            <LuShoppingBag size={15} />
            Shop Products
          </Link>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 px-6 md:px-10 py-10 min-w-0">
        {title && (
          <div className="mb-8">
            <h1 className="text-3xl font-black text-foreground tracking-tight">{title}</h1>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
